import { useSelector } from 'react-redux';

import { WithSkeleton } from '@r1-frontend/ui-react/components/loaders/Skeleton';
import { BorderRadius } from '@r1-frontend/ui-react/tokens/borderRadius';

import { TState } from '~/src/store';

import * as ST from './styled';

export type THintType = 'info' | 'success' | 'error';

export interface IHintProps {
    hintType: THintType,
    hintMessage: string,
}

const InfoHint = ({ hintType, hintMessage }: IHintProps): JSX.Element => {
    const paySumIsLoading = useSelector((state: TState) => state.seasonTicketPayment.paySumIsLoading);

    return (
        <ST.HintWrapper
            type={hintType}
            isLoading={paySumIsLoading}
        >
            <WithSkeleton
                isLoading={paySumIsLoading}
                count={2}
                borderRadius={BorderRadius.OuterBlockRadius}
                style={{
                    margin: '4px 0',
                }}>
                <>
                    <ST.HintIcon>
                        <svg>
                            <use href={`/static/images/payments-abn/hint-sprite.svg#${hintType}`}/>
                        </svg>
                    </ST.HintIcon>
                    <ST.HintMessage>{hintMessage}</ST.HintMessage>
                </>
            </WithSkeleton>
        </ST.HintWrapper>
    );
};

export default InfoHint;
